<script setup>
import BgLogin from '../../../images/bg-login-left.png'
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 m-auto w-full">
    <div>
      <img :src="BgLogin" alt="" class="w-full hidden sm:block max-h-[650px]" />
    </div>
    <div class="bg-[#1C2833]">
      <form
        name="dangky"
        method="post"
        enctype="multipart/form-data"
        action="/dang-ky"
        ng-submit="register()"
        class="h-full flex flex-col justify-center it gap-4 px-5 py-5 sm:px-10"
      >
        <h2
          class="text-white font-medium text-3xl text-center mb-3 font-[Inder]"
        >
          Đăng ký
        </h2>
        <div class="w-full">
          <div class="input-group">
            <label
              for="username_show"
              class="text-white font-normal text-xl text-center font-[Inder]"
              >Tên hiển thị</label
            >
            <input
              type="text"
              class="w-full rounded mt-1 bg-white text-black placeholder:text-black placeholder:opacity-75 block"
              id="staticEmail"
              placeholder="Tên hiển thị"
              name="username_show"
              required
            />
          </div>
        </div>
        <div class="w-full">
          <div class="input-group">
            <label
              for="username"
              class="text-white font-normal text-xl text-center font-[Inder]"
              >Tên tài khoản</label
            >
            <input
              class="w-full rounded mt-1 font-normal bg-white text-base text-black placeholder:text-black placeholder:opacity-75"
              id="checkuser"
              name="username"
              placeholder="Nhập tài khoản"
              ng-model="username"
              ng-required="true"
              required
            />

            <span class="input-group-text fa-solid fa-signature"></span>
          </div>
        </div>
        <div class="w-full">
          <div class="input-group">
            <label
              for="password"
              class="text-white font-normal text-xl text-center font-[Inder]"
              >Mật khẩu</label
            >
            <input
              type="password"
              id="password"
              class="w-full rounded mt-1 font-normal bg-white text-base text-black placeholder:text-black placeholder:opacity-75"
              name="password"
              ng-model="password"
              placeholder="Nhập mật khẩu"
              ng-required="true"
              minlength="8"
              autocomplete="password"
              required
            />
            <span class="input-group-text fa-solid fa-key"></span>
          </div>
        </div>
        <div class="w-full">
          <div class="input-group">
            <label
              for="email"
              class="text-white font-normal text-xl text-center font-[Inder]"
              >Email</label
            >
            <input
              type="email"
              class="w-full rounded mt-1 font-normal bg-white text-base text-black placeholder:text-black placeholder:opacity-75"
              name="email"
              placeholder="Nhập email đăng ký"
              required
            />
            <span class="input-group-text fa-solid fa-envelope"></span>
          </div>
        </div>
        <!-- btn dangky & dangnhap -->
        <div class="flex gap-2 justify-center">
          <button
            class="bg-[#239B56] p-2 py-2 px-5 text-2xl font-normal text-white rounded"
            name="register"
            type="submit"
          >
            Đăng ký
          </button>
        </div>
        <slot></slot>
      </form>
    </div>
  </div>
</template>
